export enum $auditRule {
  _id = '_id',
  atCombination = 'atCombination',
  actualResult = 'actualResult',
  applicableElementsSelectors = 'applicableElementsSelectors',
  categories = 'categories',
  complexity = 'complexity',
  description = 'description',
  disabilitiesAffected = 'disabilitiesAffected',
  enabled = 'enabled',
  functionalImpact = 'functionalImpact',
  history = 'history',
  href = 'href',
  isAvailableForScanning = 'isAvailableForScanning',
  isDisabled = 'isDisabled',
  isSelectedForScanning = 'isSelectedForScanning',
  reasonForImportance = 'reasonForImportance',
  recommendation = 'recommendation',
  results = 'results',
  ruleId = 'ruleId',
  severity = 'severity',
  severityNumber = 'severityNumber',
  standards = 'standards',
  stepsToReproduce = 'stepsToReproduce',
  successCriterias = 'successCriterias',
  techniques = 'techniques',
  testType = 'testType',
  title = 'title',
  tool = 'tool',
  toolVersions = 'toolVersions',
  whatToDo = 'whatToDo',
  weight = 'weight',
  wcagCriteria = 'wcagCriteria',
  wcagConformanceLevel = 'wcagConformanceLevel',
  ruleLibrary = 'ruleLibrary',
  category = 'category',
  mediaType = 'mediaType',
  bestPracticeId = 'bestPracticeId',
  testId = 'testId',
  testName = 'testName',
  testManualSteps = 'testManualSteps',
  mapsTo = 'mapsTo',
  referencedRule = 'referencedRule',
  userImpact = 'userImpact',
  compliantCodeExample = 'compliantCodeExample',
  nonCompliantCodeExample = 'nonCompliantCodeExample',
  effort = 'effort',
  tenantId = 'tenantId',
  createdAt = 'createdAt',
  hasAutomatedRemediation = 'hasAutomatedRemediation',
  en301549SuccessCriteriaIds = 'en301549SuccessCriteriaIds',
  section508SuccessCriteriaIds = 'section508SuccessCriteriaIds',
  aiTestingEnabled = 'aiTestingEnabled',
}

export enum $auditRuleStandard {
  wcag_20 = 'wcag_20',
  wcag_21 = 'wcag_21',
  wcag_22 = 'wcag_22',
  best_practice = 'best_practice',
}

export enum $auditRuleSearch {
  levels = 'levels',
  severities = 'severities',
  standards = 'standards',
  tools = 'tools',
  ruleTitles = 'ruleTitles',
  ruleIdSubstring = 'ruleIdSubstring',
  ruleTitleSubstring = 'ruleTitleSubstring',
  ruleDescriptionSubstring = 'ruleDescriptionSubstring',
  ruleIdOrKeyword = 'ruleIdOrKeyword',
  ruleLibrary = 'ruleLibrary',
  successCriteriaIds = 'successCriteriaIds',
  section508SuccessCriteriaIds = 'section508SuccessCriteriaIds',
  en301549SuccessCriteriaIds = 'en301549SuccessCriteriaIds',
  category = 'category',
  testGuideId = 'testGuideId',
}

export const ManualCustomRulePrefix: string = 'man-cust-';

export enum AuditRuleAction {
  Create = 'Create',
  Update = 'Update',
}
